export const featureFlags = {
    budget: false,
}
